export function useInventoryAPI() {
  const { errors, request } = useRequest();

  async function getLocationByFitterId() {
    const url = 'V3/Inventory/GetLocationByFitterId';

    return await request<LocationDTO[]>(url);
  }

  async function GetLocationItems(requestBody: LocationItemForLocationIdsRequest, includeImages: boolean) {
    const url = `V3/Inventory/GetLocationItems?includeImages=${includeImages}`;

    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<LocationItems>(url, requestOptions);
  }

  async function moveItemsBetweenLocations(locationItem: MoveLocationItemRequest) {
    const url = 'V3/Inventory/MoveItemsBetweenLocations';

    const requestOptions: RequestOptions = {
      method: 'post',
      body: locationItem
    };

    return await request<LocationItem[]>(url, requestOptions);
  }

  async function getLocationItemForLocation(itemId: number, locationId: string) {
    const params = new URLSearchParams({
      itemId: itemId.toString(),
      locationId: locationId.toString()
    });
    const url = `V3/Inventory/GetLocationItemForLocation?${params.toString()}`;

    return await request<LocationItem>(url);
  }

  return {
    errors,
    moveItemsBetweenLocations,
    getLocationByFitterId,
    GetLocationItems,
    getLocationItemForLocation
  };
}
